<template>
    <adaptive-modal
        name="mdu-details"
        :hide-action-buttons="true"
        @before-open="beforeOpen"
    >
        <table v-if="addresses" class="table">
            <thead>
                <tr>
                    <td>Adress</td>
                    <td>Grävstatus</td>
                    <td>Installationsstatus</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="address in addresses">
                    <td>{{ address.full_address_with_apartment_number }}</td>
                    <td class="text-center">
                        <font-awesome-icon
                            v-if="diggingCompleted(address)"
                            icon="check-circle"
                            class="text-success"
                        />
                        <font-awesome-icon
                            v-else
                            icon="times"
                            class="text-danger"
                        />
                    </td>
                    <td class="text-center">
                        <font-awesome-icon
                            v-if="installationCompleted(address)"
                            icon="check-circle"
                            class="text-success"
                        />
                        <font-awesome-icon
                            v-else
                            icon="times"
                            class="text-danger"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </adaptive-modal>
</template>
<script>
    export default {
        data() {
            return {
                addresses: null,
            };
        },
        methods: {
            beforeOpen(obj) {
                this.addresses = obj.params;
            },
            diggingCompleted(address) {
                if (! address.delivery_phases_completed.dig) {
                    return false;
                }

                return true;
            },
            installationCompleted(address) {
                if (! address.delivery_phases_completed.installation) {
                    return false;
                }

                return true;
            },
        },
    };
</script>
